import React, { useState } from 'react';
import styles from "../AddOrganisationForm/AddOrganisationForm.module.scss";
import { Field, Formik, FormikProps } from 'formik';
import { Input } from '../common/Input';

import * as yup from 'yup';
import { OrganisationData } from '../../apollo/types/OrganisationData';
import sectors from '../../enums/sectors';
import { useQuery } from '@apollo/client';
import { ORGANISATIONS_LIST } from '../../apollo/queries';
import { FileUpload } from '../common/FileUpload';


export interface OrganisationDataPlusUrl extends OrganisationData {
    urlPrefix?: string
}
interface OrganisationFormInput {
    formikRef: React.Ref<FormikProps<OrganisationDataPlusUrl>>;
    submitValues: Function;
    formData?: OrganisationDataPlusUrl
    updating?: boolean
}




export const OrganisationForm = ({
    formikRef,
    submitValues,
    formData,
    updating = false
  }: OrganisationFormInput) => {
    const [organisations, setOrganisations] = useState([])

    let validationSchema = yup.object().shape({
        venture: yup.string().required(),
        parentId: yup.number().required(),
        institutionUuid: yup.string().required(),
        contactPerson: yup.string().required(),
    });

    if(!updating) {
        validationSchema = yup.object().shape({
            venture: yup.string().required(),
            parentId: yup.number().required(),
            institutionUuid: yup.string().required(),
            contactPerson: yup.string().required(),
            urlPrefix: yup.string().required(),
        });
    }


  const initialFormValues = {
    venture: formData?.venture ?? "",
    address: formData?.address ?? "",
    city: formData?.city ?? "",
    sector: formData?.sector ?? "",
    contactPerson: formData?.contactPerson ?? '',
    website: formData?.website ?? '',
    institutionUuid: formData?.institutionUuid ?? '',
    parentId:  formData?.parentId ?? 0,
    urlPrefix: formData?.urlPrefix ?? ''
  };

    useQuery(ORGANISATIONS_LIST, {
        variables: {
            type: 'ADMIN'
        },
        fetchPolicy: 'no-cache',
        onCompleted: (someData) => {
            setOrganisations(someData.organisations)
        }
    });

  return (
      <Formik
          enableReinitialize
          validationSchema={validationSchema}
          initialValues={initialFormValues}
          onSubmit={(values) => {
              console.log('submitting values in organisationForm', values)
              if(values.parentId === 0) {
                  // @ts-ignore
                  values.parentId = organisations[0].id
              }
              // @ts-ignore
              values.parentId = parseInt(values.parentId);

              if(!values.sector) {
                  // @ts-ignore
                  values.sector = sectors[0].key
              }

              submitValues(values)
          }}
          // @ts-ignore
          innerRef={formikRef}
      >
        {({ values, errors, touched, handleChange, handleSubmit, setFieldValue, handleBlur, isValid }) => (
            <form className={styles.formContainer} onSubmit={handleSubmit}>
              <div className={styles.inputContainer}>
                {errors.venture && touched.venture ? (
                    <span className={styles.error}>Company name is required</span>
                ) : null}
                <Field
                    name='venture'
                    as={Input}
                    type='text'
                    autoFocus={true}
                    placeholder='Company name'
                    onChange={handleChange}
                    onBlur={() => {
                        if(!updating) {
                            setFieldValue('urlPrefix', values.venture.toLowerCase().replaceAll(' ', '-'))
                        }
                    }}
                    value={values.venture}
                />
              </div>
              <div className={styles.inputContainerHalf}>
                <Field
                    name='address'
                    as={Input}
                    type='text'
                    placeholder='Address'
                    onChange={handleChange}
                    value={values.address}
                />
                <Field
                    name='city'
                    as={Input}
                    type='text'
                    placeholder='City'
                    onChange={handleChange}
                    value={values.city}
                />
              </div>
              <div className={styles.inputContainerHalf}>
                <div style={{width: '100%'}}>
                  {errors.contactPerson && touched.contactPerson ? (
                      <span className={styles.error}>Contact person is required</span>
                  ) : null}
                  <Field
                      name='contactPerson'
                      as={Input}
                      type='text'
                      placeholder='Contact person'
                      onChange={handleChange}
                      value={values.contactPerson}
                  />
                </div>
                <Field
                    name='website'
                    as={Input}
                    type='text'
                    placeholder='Website'
                    onChange={handleChange}
                    value={values.website}
                />
              </div>
              <div className={styles.inputContainer}>
                {errors.institutionUuid && touched.institutionUuid ? (
                    <span className={styles.error}>UUID is required</span>
                ) : null}
                <Field
                    name='institutionUuid'
                    as={Input}
                    type='text'
                    placeholder='UUID'
                    onChange={handleChange}
                    value={values.institutionUuid}
                />
              </div>
              <div className={styles.selectContainer}>
                <Field
                    className={styles.select}
                    name='sector'
                    as="select"
                    placeholder='Sector'
                    onChange={handleChange}
                >
                  {
                    // @ts-ignore
                    sectors.map((el) => (
                        <option key={el.key} value={el.key}>{el.text.en}</option>
                    ))
                  }
                </Field>
              </div>
              <div className={styles.selectContainer}>
                { organisations &&
                  <Field
                      className={styles.select}
                      name='parentId'
                      as="select"
                      placeholder='Organisation Parent'
                      onChange={handleChange}
                  >
                    {
                      // @ts-ignore
                      organisations.map((el) => (
                          // @ts-ignore
                          <option key={el.id} value={el.id}>{el.name}</option>
                      ))
                    }
                  </Field>
                }
              </div>
                {!updating &&
                    <div className={styles.inputContainer}>
                        {errors.urlPrefix && touched.urlPrefix ? (
                            <span className={styles.error}>URL prefix is required</span>
                        ) : null}
                        <Field
                            name='urlPrefix'
                            as={Input}
                            type='text'
                            placeholder='Assessment URL prefix'
                            onChange={handleChange}
                            value={values.urlPrefix}
                        />
                    </div>
                }
            </form>
        )}
      </Formik>
  );
};
